module.exports = __webpack_public_path__ + "assets/img/logo.ad4d3cf1.png";